module.exports = __webpack_public_path__ + "img/syzg.736780a1.png";